var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContactManagementTranslation } from '../../../../../ui/hooks';
import { CardGrid } from '@juvare/common-web-ui/CardGrid';
import { DraggableCard } from '@juvare/common-web-ui/Cards/DraggableCard';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import { Checkbox, FormControlLabel, Grid, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { CsvPreviewTable } from './CsvPreviewTable';
export const ColumnOrderStep = React.forwardRef((props, ref) => {
    const { t } = useContactManagementTranslation();
    const selectedFields = props.data.selectedFields;
    const cardRef = React.useRef(null);
    const [isSave, setIsSave] = React.useState(!!props.templateName);
    const [templateName, setTemplateName] = React.useState(props.templateName);
    const [sortedFields, setSortedFields] = React.useState(selectedFields);
    const cleanSortedFields = sortedFields.map((item) => 
    // Removing id, because it's only useful to data table and card grid
    // Can't use destructuring because of eslint rules
    Object.fromEntries(Object.entries(item).filter(([key]) => key !== 'id')));
    const items = sortedFields.map(({ headerName, id }) => ({
        id,
        label: headerName,
    }));
    const handleIsSaveChange = (event) => {
        setIsSave(event.target.checked);
    };
    const handleNameChange = (event) => {
        if (event) {
            setTemplateName(event.target.value);
        }
    };
    const handleFieldSortChange = (newSortedFields) => {
        setSortedFields(newSortedFields);
    };
    React.useImperativeHandle(ref, () => ({
        getData: () => ({
            sortedFields: cleanSortedFields,
            name: templateName,
        }),
        submit: () => __awaiter(void 0, void 0, void 0, function* () {
            if (isSave && !(templateName === null || templateName === void 0 ? void 0 : templateName.trim())) {
                return Promise.reject(t('export.templateNameIsRequired'));
            }
            const response = yield props.onSubmit({ sortedFields: cleanSortedFields, name: templateName });
            return props.onSubmitSuccess({ sortedFields: cleanSortedFields, name: templateName }, response);
        }),
    }));
    return (React.createElement(Grid, { container: true, spacing: 2, alignItems: 'stretch' },
        React.createElement(Grid, { size: {
                xs: 12,
                sm: 9,
            } },
            React.createElement(Stack, { gap: 2 },
                React.createElement(Stack, { gap: 2, p: 2, bgcolor: themeColors.surface.secondary, borderRadius: 1 },
                    React.createElement(Typography, { variant: 'subtitle2' }, t('export.preview')),
                    React.createElement(CsvPreviewTable, { headingItems: items, rowsCount: 5 })),
                React.createElement(Grid, { container: true, p: 3, borderRadius: 1, bgcolor: themeColors.surface.secondary, alignItems: 'center' },
                    React.createElement(Grid, { py: 1, size: {
                            xs: 12,
                            sm: 6,
                        } },
                        React.createElement(FormControlLabel, { disabled: props.disableSaveAsExport, control: React.createElement(Checkbox, { checked: isSave, onChange: handleIsSaveChange }), label: t('export.saveAsExportTemplate') })),
                    isSave && (React.createElement(Grid, { size: {
                            xs: 12,
                            sm: 6,
                        } },
                        React.createElement(TextField, { defaultValue: props.templateName, fullWidth: true, required: true, label: t('export.exportTemplateName'), onChange: handleNameChange })))))),
        React.createElement(Grid, { size: {
                xs: 12,
                sm: 3,
            } },
            React.createElement(Stack, { gap: 2, p: 2, bgcolor: themeColors.surface.secondary, borderRadius: 1 },
                React.createElement(Stack, { direction: 'row', gap: 2, justifyContent: 'space-between', alignItems: 'center' },
                    React.createElement(Typography, { variant: 'subtitle2' }, t('export.dragField')),
                    React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, t('export.fields', { count: selectedFields.length }))),
                React.createElement(CardGrid, { columns: { xs: 1 }, sx: {
                        maxHeight: '416px',
                        overflow: 'scroll',
                    }, gap: 1, editable: true, cards: sortedFields, onChange: handleFieldSortChange, renderCard: (props, card) => (React.createElement(DraggableCard, Object.assign({}, props, { getCardBoundingRect: () => {
                            const element = cardRef.current;
                            if (element) {
                                element.style.transform = 'none';
                                const rect = element.getBoundingClientRect();
                                element.style.transform = '';
                                return rect;
                            }
                            else {
                                return undefined;
                            }
                        } }),
                        React.createElement(Stack, { alignItems: 'center', direction: 'row', p: 1, gap: 2 },
                            React.createElement(DragIndicatorOutlinedIcon, { htmlColor: themeColors.icon.subtle }),
                            React.createElement(Typography, { variant: 'caption' }, card.headerName)))) })))));
});
